import Vue from 'vue'
import axios from 'axios'
import qs from 'qs' // 用到post请求时
import { Message } from 'element-ui'
Vue.prototype.$axios = axios;
// axios.defaults.timeout = 8000
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
//axios.defaults.baseURL = process.env.API_ROOT
// axios.defaults.baseURL = 'http://www.henglian.com/api'
axios.defaults.baseURL = 'https://www.kuanbaorui.com'
// axios.defaults.baseURL = '/proxyApi'
//axios.defaults.baseURL ='/';

// 添加请求拦截器 // https://cloud.tencent.com/developer/article/1339368
axios.interceptors.request.use((config) => {
  // 在发送请求之前做些什么
  // console.log('请求前：', config)
  // console.log('接口域名：', axios.defaults.baseURL)
  return config
}, (error) => {
  // 对请求错误做些什么
  // console.log('请求前错误：', error)
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use((response) => {
  // 对响应数据做点什么
  // console.log('响应数据：', response)
  return response
}, (error) => {
  // 对响应错误做点什么
  // console.log('响应数据错误：', error)
  return Promise.reject(error)
})

// GET请求
export function get(url, datas, name) {
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas})
      .then(res => {
        let c = res.data.code
        if (c === 1) {
          // console.log(name + ' get接口  成功：', res)
          resolve(res.data)
        } else {
          // console.log(name + ' get接口  【异常】：', res)
          Message({
            type: 'warning', // 类型，可选值 success/warning/info/error //https://element.eleme.cn/#/zh-CN/component/message
            message: res.data.msg,
            duration: 2000,
			offset:200,
            center: true
          })
        }
      }).catch(err => {
        // console.log(name + ' get接口  失败：', err)
        reject(err)
      })
  })
}

// POST请求
export function post(url, datas,name) {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(datas))
      .then(res => {
        let c = res.data.code
        if (c === 1) {
          // console.log(name + ' post接口  成功：', res)
          resolve(res.data)
        } else {
          // console.log(name + ' post接口  【异常】：', res)
          Message({
            type: 'warning',
            message: res.data.msg,
            duration: 2000,
			offset:60,
            center: true
          })
		  resolve(res.data)
        }
      })
      .catch(err => {
        // console.log(name + ' post接口  失败：', err)
        reject(err)
      })
  })
}

export default {
  // get接口
  indexInfo: (datas) => get('首页数据', '/index/index', datas),
  bannerImg: (datas) => get('banner图', '/index/banner', datas),
  footerNews: (datas) => get('页脚新闻列表', '/index/article', datas),
  aboutUS: (datas) => get('关于恒连', '/about/index', datas),
  staffsList: (datas) => get('员工风采列表', '/about/staffList', datas),
  staffsInfo: (datas) => get('员工风采详情', '/about/staffDetail', datas),
  ventureList: (datas) => get('创投列表', '/capital/capitalList', datas),
  newsList: (datas) => get('新闻列表', '/article/articleList', datas),
  newsInfo: (datas) => get('新闻内容', '/article/articleDetail', datas),
  jobList: (datas) => get('招聘列表', '/job/jobList', datas),
  contactList: (datas) => get('联系方式', '/contact/contactList', datas),
  // captcha: (datas) => get('验证码', '/verify_code/captcha', datas),
  phoneCode: (datas) => get('手机验证码', '/contact/sendSms', datas),


  // post接口
  leaveWord: (datas) => post('提交留言', '/contact/addComment', datas)
}
